import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { GET_AGREEMENT, actionCreators } from './action';
import agreement_PL from '../../translations/pl_PL/blog/agreement.json';
import agreement_EN from '../../translations/en_GB/blog/agreement.json';

const agreements = {
  'en_GB': agreement_EN, 
  'pl_PL': agreement_PL
}

function* onGetAgreementSaga() {
    try {
      // call to api
      // const response = yield call(fetch, 'http://localhost:8080/agreement');
      // const agreementData = yield response.json();
      // put response to store

      const language = yield select((state) => state.language);
      

      yield put(actionCreators.putAgreement(agreements[language]));
    }
    catch(error) {
      yield put(actionCreators.putAgreement(null));
    }
  }

function* getAgreementSaga() {
	yield takeEvery(GET_AGREEMENT, onGetAgreementSaga);
}

export function* agreementSaga() {
	yield all([fork(getAgreementSaga)]);
}
